import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import TabPanel from '../../../../components/common/TabPanel';
import FormSettings from './FormSettings';
import DashboardSettings from './DashboardSettings';
import PickupAndDeliverySettings from './PickupAndDeliverySettings';

function CateringSettingsContent() {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const tabs = [
        { label: 'Form Settings', value: 0 },
        { label: 'Dashboard Settings', value: 1 },
        { label: 'Pickup & Delivery Settings', value: 2 },
    ];

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    aria-label="Catering Settings Tabs"
                    scrollButtons="auto"
                    variant="scrollable"
                >
                    {tabs.map(({ label, value }) => (
                        <Tab
                            key={value}
                            label={label}
                            id={`catering-settings-tab-${value}`}
                            aria-controls={`catering-settings-tabpanel-${value}`}
                        />
                    ))}
                </Tabs>
            </Box>

            {/* Form Settings Tab */}
            <TabPanel value={activeTab} index={0}>
                <FormSettings />
            </TabPanel>

            {/* Dashboard Settings Tab */}
            <TabPanel value={activeTab} index={1}>
                <DashboardSettings />
            </TabPanel>

            {/* Pickup & Delivery Settings Tab */}
            <TabPanel value={activeTab} index={2}>
                <PickupAndDeliverySettings orderType="catering" mode="pickup" />
            </TabPanel>
        </Box>
    );
}

CateringSettingsContent.propTypes = {};

export default CateringSettingsContent;
